import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLineLegend = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 10,
	viewBox: "0 0 23 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			y: 3.5,
			width: 23,
			height: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5 8.5C13.433 8.5 15 6.933 15 5C15 3.067 13.433 1.5 11.5 1.5C9.567 1.5 8 3.067 8 5C8 6.933 9.567 8.5 11.5 8.5Z",
			fill: "white",
			stroke: "currentColor",
			strokeWidth: 2
		})
	]
});
const ForwardRef = forwardRef(SvgLineLegend);
export default ForwardRef;
